module.exports = __webpack_public_path__ + "static/tooltip3-eac8611999762c380137e8537297177e.png";